export enum UserRoleBackend {
  MANAGER = 'manager',
  FIELDWORKER = 'fieldworker',
  BACKOFFICE = 'backoffice',
  TEAMMATE = 'teammate',
}
